/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { S as LabeledInputSig } from "ui-kit/components/changeset/labeled-input";

interface S {
  Args: Pick<
    LabeledInputSig["Args"],
    "changeset" | "isMandatory" | "propertyName"
  > & {
    name?: LabeledInputSig["Args"]["placeholder"];
    onSelected?: unknown;
    propertyName?: unknown;
    query?: unknown;
    suggestionsAreVisible?: unknown;
  };
}

import Component from "@glimmer/component";

import styles from "./index.module.css";
export default class extends Component<S> {
  styles = styles;
}
